import React, { useState } from 'react';
import { Popover, Box, Typography, Select, MenuItem, Button, Grid, FormControl, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const PopoverContainer = styled(Box)(({ theme }) => ({
  width: 350,
  padding: theme.spacing(3),
  borderRadius: '8px',
}));

const Label = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
}));

const LeadFilter = ({ open, onClose, anchorEl }) => {
  const [filters, setFilters] = useState({
    employee: 'All',
    leadStatus: 'Open',
    fromDate: '2025-07-01T12:00',
    toDate: '2025-07-01T12:00',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <PopoverContainer>
        <Typography variant="h6" gutterBottom>Filter</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label>Employee</Label>
            <FormControl fullWidth size="small">
              <Select name="employee" value={filters.employee} onChange={handleChange}>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Mamta Kumari">Mamta Kumari</MenuItem>
                <MenuItem value="Umesh Sharma">Umesh Sharma</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Label>Lead Status</Label>
            <FormControl fullWidth size="small">
              <Select name="leadStatus" value={filters.leadStatus} onChange={handleChange}>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Label>From Date</Label>
            <TextField
              fullWidth
              size="small"
              name="fromDate"
              type="datetime-local"
              value={filters.fromDate}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Label>To Date</Label>
            <TextField
              fullWidth
              size="small"
              name="toDate"
              type="datetime-local"
              value={filters.toDate}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
          <Button variant="outlined" color="error" onClick={onClose}>Reset</Button>
          <Button variant="contained">Apply</Button>
        </Box>
      </PopoverContainer>
    </Popover>
  );
};

export default LeadFilter;
